import { takeLatest } from 'redux-saga/effects';
import ActionTypes from '@ziynx/action-types';
import {
  checkStatus, checkAdmin, logout, verifyAccount, signUp,
} from './auth.saga';
import {
  getProfile, patchProfile, getProfileResponses, putTalentNotes,
} from './profile.saga';
import {
  postCompany, patchCompany, getCompany, patchCompanyImage,
} from './company.saga';
import {
  getPresignedUrl, uploadMediaAsset, checkUploadStatus, editMediaAsset,
} from './media.saga';
import {
  getInvite,
  getTeamList,
  postInvite,
  patchInvite,
  removeUser,
  removeInvite,
  getUser,
  patchUser,
  resendInvite,
} from './team.saga';
import { getUserInit, getUserInfo, patchUserInfo } from './user.saga';
import {
  getAll, getQuestion, patchQuestion, postQuestion, removeQuestion, getQuestionResponses,
} from './statements.saga';
import {
  getAllJobs, getJob, archive, patchJob, postJob, removeJob,
} from './job.saga';
import {
  getDiscover, getChannel, getWatchlist, addToWatchlist, removeFromWatchlist, postFilters,
} from './discover.saga';
import {
  postTrackingPlay, postTrackingView, changeUser, logEvent, openSession, setCustomAttribute,
} from './analytics.saga';
import { viewedProfile, viewedMyShot, viewedResponse } from './trackingAction.saga';
import {
  addNotification,
} from './notifications.saga';
import {
  getLocation,
  getJobLocation,
  getGraduationYears,
  getInterests,
  getCharacterTraits,
  getCompanies,
  getCompanyQuestions,
  getCollegeLeague,
} from './search.saga';
import { postIntakeSubmission } from './intake.saga';
import {
  getAllScorecards,
  getTalentScorecard,
  getTalentScorecardValues,
  patchTalentScorecard,
  talentFilters,
} from './admin.saga';
import {
  getAllNIL, postNIL, getNIL, patchNIL, deleteNIL, getNILApplications,
} from './nil.saga';
import {
  getAllOriginals, postOriginal, getOriginal, patchOriginal, deleteOriginal,
} from './originals.saga';

export default function* watchSaga() {
  /** AUTH */
  yield takeLatest(ActionTypes.auth.checkIfLoggedIn.START, checkStatus);
  yield takeLatest(ActionTypes.auth.checkIfAdmin.START, checkAdmin);
  yield takeLatest(ActionTypes.auth.logout.START, logout);
  yield takeLatest(ActionTypes.auth.signUp.START, signUp);
  yield takeLatest(ActionTypes.auth.verifyAccount.START, verifyAccount);
  /** ADMIN */
  yield takeLatest(ActionTypes.admin.getAllScorecards.START, getAllScorecards);
  yield takeLatest(ActionTypes.admin.getTalentScorecard.START, getTalentScorecard);
  yield takeLatest(ActionTypes.admin.getTalentScorecardValues.START, getTalentScorecardValues);
  yield takeLatest(ActionTypes.admin.patchTalentScorecard.START, patchTalentScorecard);
  yield takeLatest(ActionTypes.admin.talentFilters.START, talentFilters);
  /** USER */
  yield takeLatest(ActionTypes.user.init.START, getUserInit);
  yield takeLatest(ActionTypes.user.getInfo.START, getUserInfo);
  yield takeLatest(ActionTypes.user.patch.START, patchUserInfo);
  /** PROFILE */
  yield takeLatest(ActionTypes.profile.get.START, getProfile);
  yield takeLatest(ActionTypes.profile.patch.START, patchProfile);
  yield takeLatest(ActionTypes.profile.getResponses.START, getProfileResponses);
  yield takeLatest(ActionTypes.profile.putTalentNotes.START, putTalentNotes);

  /** COMPANIES */
  yield takeLatest(ActionTypes.company.post.START, postCompany);
  yield takeLatest(ActionTypes.company.patch.START, patchCompany);
  yield takeLatest(ActionTypes.company.patchImage.START, patchCompanyImage);
  yield takeLatest(ActionTypes.company.get.START, getCompany);

  /** MEDIA */
  yield takeLatest(ActionTypes.media.checkUploadStatus.START, checkUploadStatus);
  yield takeLatest(ActionTypes.media.getPresignedUrl.START, getPresignedUrl);
  yield takeLatest(ActionTypes.media.uploadMediaAsset.START, uploadMediaAsset);
  yield takeLatest(ActionTypes.media.editMediaAsset.START, editMediaAsset);

  /** TEAM MEMBER */
  yield takeLatest(ActionTypes.teamMember.getInvite.START, getInvite);
  yield takeLatest(ActionTypes.teamMember.getUser.START, getUser);
  yield takeLatest(ActionTypes.teamMember.post.START, postInvite);
  yield takeLatest(ActionTypes.teamMember.patchInvite.START, patchInvite);
  yield takeLatest(ActionTypes.teamMember.patchUser.START, patchUser);
  yield takeLatest(ActionTypes.teamMember.resendInvite.START, resendInvite);
  yield takeLatest(ActionTypes.teamMember.removeInvite.START, removeInvite);

  /** TEAM */
  yield takeLatest(ActionTypes.team.get.START, getTeamList);
  yield takeLatest(ActionTypes.team.removeUser.START, removeUser);

  /** DISCOVER */
  yield takeLatest(ActionTypes.discover.get.START, getDiscover);
  yield takeLatest(ActionTypes.discover.getChannel.START, getChannel);
  yield takeLatest(ActionTypes.discover.postFilters.START, postFilters);

  /** WATCHLIST */
  yield takeLatest(ActionTypes.watchlist.get.START, getWatchlist);
  yield takeLatest(ActionTypes.watchlist.add.START, addToWatchlist);
  yield takeLatest(ActionTypes.watchlist.remove.START, removeFromWatchlist);

  /** ANALYTICS */
  yield takeLatest(ActionTypes.analytics.changeUser.START, changeUser);
  yield takeLatest(ActionTypes.analytics.logEvent.START, logEvent);
  yield takeLatest(ActionTypes.analytics.setCustomAttribute.START, setCustomAttribute);
  yield takeLatest(ActionTypes.analytics.openSession.START, openSession);
  yield takeLatest(ActionTypes.analytics.trackPlay.START, postTrackingPlay);
  yield takeLatest(ActionTypes.analytics.trackView.START, postTrackingView);

  /** TRACKING ACTION */
  yield takeLatest(ActionTypes.trackingAction.viewedProfile.START, viewedProfile);
  yield takeLatest(ActionTypes.trackingAction.viewedResponse.START, viewedResponse);
  yield takeLatest(ActionTypes.trackingAction.viewedMyShot.START, viewedMyShot);

  /** STATEMENTS */
  yield takeLatest(ActionTypes.statements.getAll.START, getAll);
  yield takeLatest(ActionTypes.statements.removeQuestion.START, removeQuestion);

  /** STATEMENT ITEM */
  yield takeLatest(ActionTypes.statementItem.getQuestion.START, getQuestion);
  yield takeLatest(ActionTypes.statementItem.postQuestion.START, postQuestion);
  yield takeLatest(ActionTypes.statementItem.patchQuestion.START, patchQuestion);
  yield takeLatest(ActionTypes.statementItem.getQuestionResponses.START, getQuestionResponses);

  /** JOBS */
  yield takeLatest(ActionTypes.job.getAllJobs.START, getAllJobs);
  yield takeLatest(ActionTypes.job.removeJob.START, removeJob);

  /** JOB ITEM */
  yield takeLatest(ActionTypes.jobItem.getJob.START, getJob);
  yield takeLatest(ActionTypes.jobItem.archive.START, archive);
  yield takeLatest(ActionTypes.jobItem.patchJob.START, patchJob);
  yield takeLatest(ActionTypes.jobItem.postJob.START, postJob);

  /** NOTIFICATIONS */
  yield takeLatest(ActionTypes.notifications.add.START, addNotification);

  /** SEARCH */
  yield takeLatest(ActionTypes.search.getLocation.START, getLocation);
  yield takeLatest(ActionTypes.search.getJobLocation.START, getJobLocation);
  yield takeLatest(ActionTypes.search.getInterests.START, getInterests);
  yield takeLatest(ActionTypes.search.getCollegeLeague.START, getCollegeLeague);
  yield takeLatest(ActionTypes.search.getGraduationYears.START, getGraduationYears);
  yield takeLatest(ActionTypes.search.getCharacterTraits.START, getCharacterTraits);
  yield takeLatest(ActionTypes.search.getCompanies.START, getCompanies);
  yield takeLatest(ActionTypes.search.getCompanyQuestions.START, getCompanyQuestions);

  /** INTAKE */
  yield takeLatest(ActionTypes.intake.postIntakeSubmission.START, postIntakeSubmission);

  /** NIL */
  yield takeLatest(ActionTypes.NIL.getAll.START, getAllNIL);
  yield takeLatest(ActionTypes.NIL.get.START, getNIL);
  yield takeLatest(ActionTypes.NIL.post.START, postNIL);
  yield takeLatest(ActionTypes.NIL.patch.START, patchNIL);
  yield takeLatest(ActionTypes.NIL.delete.START, deleteNIL);
  yield takeLatest(ActionTypes.NIL.applications.getAll.START, getNILApplications);

  /** ORIGINALS */
  yield takeLatest(ActionTypes.originals.getAll.START, getAllOriginals);
  yield takeLatest(ActionTypes.originals.get.START, getOriginal);
  yield takeLatest(ActionTypes.originals.post.START, postOriginal);
  yield takeLatest(ActionTypes.originals.patch.START, patchOriginal);
  yield takeLatest(ActionTypes.originals.delete.START, deleteOriginal);
}
